import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const RefreshSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default RefreshSVG;
